import React from "react";
import Item from "./components/Item";

type Props = {};

type State = {};

class Projects extends React.Component<Props, State> {
    state = {};

    render() {
        return (
            <div className="Projects" id="projects">
                <h1 style={{ textAlign: "center" }}>Projects</h1>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="row">
                            <div className="col">
                                <h2>Language Technology</h2>
                            </div>
                        </div>
                        <Item
                            heading="Generalization in Hierarchical Topic Classification"
                            duration="January 2021 - May 2021"
                            role=""
                        >
                            <ul>
                                <li>
                                    Developed a robust hierarchical topic
                                    classifier for Tweets for real-time Twitter
                                    streams.{" "}
                                </li>
                                <li>Designed data augmentation algorithms.</li>
                            </ul>
                        </Item>
                        <Item
                            heading="
									Semantic
									Textual
									Similarity
			"
                            duration="
			June 2020 - July 2020
			"
                            role=""
                        >
                            <ul>
                                <li>
                                    Fine-tuned BERT on Microsoft Research
                                    Paraphrase Corpus.
                                </li>
                                <li>
                                    Designed a Java interface for the developed
                                    model.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="Multi-Hop Question Answering System"
                            duration="
									January
									2020 -
									May 2020
			"
                            role=""
                        >
                            <ul>
                                <li>
                                    Developed a novel Deep Learning architecture
                                    for Multi-Hop Question Answering using
                                    Wikipedia as the Open-Domain Knowledge Base.
                                </li>
                                <li>
                                    Achieved 60.10 EM and 72.30 F1 Score on
                                    HotpotQA Dataset.
                                </li>
                            </ul>
                        </Item>
                        <div className="row">
                            <div className="col">
                                <h2>Statistics</h2>
                            </div>
                        </div>
                        <Item
                            heading="Earthquake Damage Estimation"
                            duration="
			October 2018 - November 2018
			"
                            role=""
                        >
                            <ul>
                                <li>
                                    Designed a novel approach for calculating
                                    population loss due to earthquakes.
                                </li>
                                <li>
                                    Analyzed available datasets for drawing
                                    insights on earthquake magnitude and
                                    population variation.
                                </li>
                            </ul>
                        </Item>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="row">
                            <div className="col">
                                <h2>Deep Learning</h2>
                            </div>
                        </div>
                        <Item
                            heading="Anomalous Sound Detection"
                            duration="January 2021 - May 2021"
                            role=""
                        >
                            <ul>
                                <li>
                                    Designed semi-supervised models for
                                    anomalous sound detection.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="
									Multi-Lingual
									Scene
									Text
									Detection
									and
									Localization
									in Sign
									Boards
			"
                            duration="

									January
									2019 -
									May 2019
			"
                            role=""
                        >
                            <ul>
                                <li>
                                    Generalized a uni-lingual Deep Learning
                                    pipeline for multi-linguality by integrating
                                    Tesseract OCR.
                                </li>
                                <li>
                                    Designed a Named Entity Recognition system
                                    using DBPedia’s SPARQL interface.
                                </li>
                            </ul>
                        </Item>
                        <div className="row">
                            <div className="col">
                                <h2>Development</h2>
                            </div>
                        </div>
                        <Item
                            heading="Peer-to-Peer Streaming System"
                            duration="December 2020 - Present"
                            role=""
                        >
                            <ul>
                                <li>
                                    Developing a file/media sharing system for
                                    seamless streaming at LAN.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="Knowledge Graph for the Linux System"
                            duration="September 2019 - December 2019"
                            role=""
                        >
                            <ul>
                                <li>
                                    Engineered a tool for mining structured data
                                    from semi-structured, troff-format Linux
                                    manpages.
                                </li>
                            </ul>
                        </Item>
                    </div>
                </div>
            </div>
        );
    }
}

export default Projects;
